<template>
  <span id="wrapper">
    <animated-number
      :value="value"
      :formatValue="theFormat"
      :duration="2000"
      :delay="delay"
    />
  </span>
</template>
<script>
import AnimatedNumber from "animated-number-vue";

export default {
  name: "dynamic-number",
  components: {
    AnimatedNumber
  },
  data() {
    return {
      duration: 5,
      scaleClass: false
    };
  },
  props: {
    value: Number,
    delay: Number
  },
  methods: {
    theFormat(number) {
      return number.toFixed(0);
    },
    completed() {
      this.scaleClass = true;
    }
  }
};
</script>
